var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlinmaBankFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67186 13.0001C12.5424 13.0001 13.0836 12.4585 13.0836 7.58346V5.41679C13.0836 0.541789 12.5424 0.00012207 7.67186 0.00012207H5.5074C0.636818 0.00012207 0.0957031 0.541789 0.0957031 5.41679V7.58346C0.0957031 12.4585 0.636818 13.0001 5.5074 13.0001H7.67186ZM8.21297 10.2918L4.96573 11.3751V2.70846L8.21297 1.62512V10.2918Z",
    fill: "#002134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlinmaBankFavicon);
export default __webpack_public_path__ + "static/media/alinma_bank_favicon.f7d6be110a43fbae9e193aacc3596cb9.svg";
export { ForwardRef as ReactComponent };